'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.89-2-2-2zm0 14H5V8h14v10z' });

var WebAsset = function WebAsset(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

WebAsset = (0, _pure2.default)(WebAsset);
WebAsset.muiName = 'SvgIcon';

exports.default = WebAsset;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/WebAsset.js
// module id = 3016
// module chunks = 0